import { render, staticRenderFns } from "./trainer.vue?vue&type=template&id=59e5664b&"
import script from "./trainer.vue?vue&type=script&lang=js&"
export * from "./trainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports